import { render, staticRenderFns } from "./banners-draggable.vue?vue&type=template&id=c0436486"
import script from "./banners-draggable.vue?vue&type=script&lang=js"
export * from "./banners-draggable.vue?vue&type=script&lang=js"
import style0 from "./banners-draggable.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/view/banners-draggable.vue
// module id = UDvS
// module chunks = 0